import { render } from "./SolicitationList.vue?vue&type=template&id=bf0fefa6&scoped=true"
import script from "./SolicitationList.vue?vue&type=script&lang=js"
export * from "./SolicitationList.vue?vue&type=script&lang=js"

import "./SolicitationList.vue?vue&type=style&index=0&id=bf0fefa6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0fefa6"]])

export default __exports__